import React, { memo, useCallback } from 'react'

import * as styles from './quickFilterButton.module.scss'
import classNames from 'classnames'

const QuickFilterButton = ({
   id,
   label,
   amount,
   onButtonClick,
   isActive,
   isDisabled,
   isWide
}: QuickFilterButtonProps) => {
   const handleClick = useCallback(() => onButtonClick(id), [id, onButtonClick])

   const className = classNames(styles.button, {
      [styles.active]: isActive,
      [styles.wide]: isWide
   })

   // TODO in future: This could do with a refactor, this aspect of the component is not particularly generic.
   // Audit Details uses labels, as the IDs are switched using an enum of corresponding backend numbers
   const badgeClassName = classNames(styles.badge, {
      [styles.danger]:
         id === 'ActionTasks' ||
         id === 'ReminderTasks' ||
         id === 'InformationalTasks' ||
         label === 'Found' ||
         label === 'Confirmed' ||
         label === 'Unconfirmed',
      [styles.smallText]: amount > 999,
   })

   return (
      <button
         type="button"
         onClick={handleClick}
         className={className}
         disabled={isDisabled}
      >
         <span>{label}</span>
         {amount ? <span className={badgeClassName}>{amount}</span> : <></>}
      </button>
   )
}

export default memo(QuickFilterButton)
